export const maintainceHeaders = {
	customers: [
		{
			settings: true,
			text: "Division ID",
			value: "id",
			func: true,
			valueFilter: 'filter_id',
			model: { value: 'list' },
			sortable: true,
			footer: "unique"
		},
		{
			settings: true,
			text: "Customer name",
			value: "name",
			func: true,
			valueFilter: 'filter_name',
			model: { value: 'list' },
			sortable: true
		},
		{
			settings: true,
			text: "Created date",
			value: "created_at",
			func: true,
			valueFilter: 'filter_created_at',
			model: { value: 'date' },
			sortable: true
		},
		{
			settings: true,
			text: "Created by",
			value: "created_by",
			func: true,
			valueFilter: 'filter_created_by',
			model: { value: 'list' },
			sortable: true
		},
		{
			settings: true,
			text: "Email",
			value: "email",
			func: true,
			valueFilter: 'filter_email',
			model: { value: 'list' },
			sortable: true
		},
		{
			settings: true,
			text: "Phone",
			value: "phone",
			func: true,
			valueFilter: 'filter_phone',
			model: { value: 'list' },
			sortable: true
		},
		{
			settings: true,
			text: "Frozen",
			value: "frozen",
			func: true,
			valueFilter: 'filter_frozen',
			model: { value: 'list' },
			sortable: true,
			align: 'center',
			isStatus: true,
		},
		{
			settings: true,
			text: "Services",
			value: "services",
			filterSplit: true,
			func: true,
			valueFilter: 'filter_services',
			model: { value: 'list' },
			sortable: true,
			toLeft: true
		},
		/*		{
			settings: true,
			text: "Date started",
			value: "started",
			func: true,
			valueFilter: 'filter_started',
			model: { value: 'date' },
			sortable: true,
			toLeft: true
		},*/
		{
			settings: true,
			text: "Balance",
			value: "balance",
			colorDetected: true,
			func: true,
			valueFilter: 'filter_balance',
			model: { value: 'number' },
			sortable: true,
			modText: true,
			toLeft: true
		},
		{
			settings: true,
			text: "Find us",
			value: "find_us",
			colorDetected: true,
			func: true,
			valueFilter: 'filter_find_us',
			model: { value: 'list' },
			sortable: true
		},
		{
			settings: true,
			buttons: [
				{
					perm: { or: [ 10, 9 ] },
					value: 'edit',
					text: 'Edit customer',
					icon: { value: 'edit', w: 18, h: 18 },
				},
				{
					perm: {
						or: [ 11 ]
					},
					value: 'delete',
					text: 'Delete customer',
					icon: { value: 'deleteItem', w: 18, h: 18 },
				}
			]
		},
	],
	drivers: [
		{
			settings: true,
			text: "ID",
			value: "id",
			func: true,
			valueFilter: "filter_id",
			model: { value: 'list' },
			sortable: true,
			footer: "unique"
		},
		{
			settings: true,
			text: "Driver name",
			value: "driver",
			func: true,
			valueFilter: 'filter_driver',
			model: { value: 'list' },
			sortable: true
		},
		{
			settings: true,
			text: "Driver type",
			value: "driver_type",
			func: true,
			valueFilter: 'filter_driver_type',
			model: { value: 'list' },
			sortable: true,
		},
		{
			settings: true,
			text: "Safety service",
			value: "safety",
			func: true,
			valueFilter: 'filter_safety',
			model: { value: 'list' },
			sortable: true,
			modText: true,
		},
		{
			settings: true,
			text: "Salary service",
			value: "service",
			func: true,
			valueFilter: 'filter_service',
			model: { value: 'list' },
			sortable: true,
			modText: true,
		},
		{
			settings: true,
			text: "ELD",
			value: "eld_name",
			func: true,
			valueFilter: 'filter_eld_name',
			model: { value: 'note' },
			sortable: true,
		},
		{
			settings: true,
			text: "Customer",
			value: "customer",
			func: true,
			valueFilter: 'filter_customer',
			model: { value: 'list' },
			sortable: true,
			footer: "unique"
		},
		{
			settings: true,
			text: "Truck",
			value: "truck_number",
			func: true,
			valueFilter: 'filter_truck',
			model: { value: 'list' },
			sortable: true,
		},
		{
			settings: true,
			text: "Trailer",
			value: "trailer_number",
			func: true,
			valueFilter: 'filter_trailer',
			model: { value: 'list' },
			sortable: true,
		},
		{
			settings: true,
			text: "Trailer type",
			value: "trailer_type",
			func: true,
			valueFilter: 'filter_trailer_type',
			model: { value: 'list' },
			sortable: true,
			toLeft: true
		},
		{
			settings: true,
			text: "Amount",
			value: "amount",
			func: true,
			valueFilter: 'filter_amount',
			model: { value: 'number' },
			sortable: true,
			toLeft: true
		},
		{
			settings: true,
			text: "Payment type",
			value: "payment_type",
			func: true,
			valueFilter: 'filter_payment_type',
			model: { value: 'list' },
			sortable: true,
			toLeft: true
		},
		{
			settings: true,
			buttons: [
				{
					perm: { or: [ 10, 9 ] },
					value: 'edit',
					text: 'Edit driver',
					icon: { value: 'edit', w: 18, h: 18 },
				},
				{
					perm: {
						or: [ 11 ]
					},
					value: 'delete',
					text: 'Delete driver',
					icon: { value: 'deleteItem', w: 18, h: 18 },
				}
			]
		},
	]
};

export const usersHeader = [
	{
		settings: true,
		text: "ID",
		value: "id",
		func: true,
		valueFilter: 'filter_id',
		model: { value: 'list' },
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Name",
		value: "name",
		func: true,
		valueFilter: 'filter_name',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "User Group",
		value: "userGroup",
		func: true,
		valueFilter: 'filter_userGroup',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Customer",
		value: "customer",
		func: true,
		valueFilter: 'filter_customer',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Dispatcher",
		value: "dispatcher",
		func: true,
		valueFilter: 'filter_dispatcher',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Email",
		value: "email",
		func: true,
		valueFilter: 'filter_email',
		model: { value: 'list' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		text: "Updated at",
		value: "updated_at",
		func: true,
		valueFilter: 'filter_updated_at',
		model: { value: 'date' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		text: "Status",
		value: "status",
		func: true,
		valueFilter: 'filter_status',
		model: { value: 'list' },
		sortable: true,
		modText: true,
	},
	{
		settings: true,
		buttons: [
			{
				perm: { or: [ 9 ] },
				value: 'edit',
				text: 'Edit user',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete',
				text: 'Delete user',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			},
		]
	},
];

export const cityHeader = [
	{
		settings: true,
		text: "City",
		value: "city",
		func: true,
		valueFilter: 'filter_city_id',
		model: { value: 'list' },
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "ZIP",
		value: "zip_codes",
		func: true,
		valueFilter: 'filter_zip_code_id',
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "State",
		value: "state",
		func: true,
		valueFilter: 'filter_state_id',
		model: { value: 'list' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		buttons: [
			{
				perm: { or: [ 9 ] },
				value: 'edit',
				text: 'Edit city',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete',
				text: 'Delete city',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			},
		]
	},
];

export const truckNotesHeader = [
	{
		settings: true,
		text: "Created date",
		value: "filter_created_date",
		func: true,
		sortable: true,
		model: { value: 'date' },
		dense: true
	},
	{
		settings: true,
		text: "Created by",
		value: "filter_created_by",
		func: true,
		sortable: true,
		model: { value: 'list' },
		dense: true
	},
	{
		settings: true,
		text: "Notes",
		value: "notes",
		sortable: true,
		model: { value: 'list' },
		dense: true
	}
];

export const truckEquipmentsHeader = [
	{
		settings: true,
		text: "Equipment",
		value: "equipment",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Driver",
		value: "filter_driver",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false
	},
	{
		settings: true,
		text: "Receiving date",
		value: "filter_receiving_date",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Returned",
		value: "filter_returned",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false
	},
	{
		settings: true,
		text: "Returned date",
		value: "filter_returned_date",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Notes",
		value: "notes",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	}
];

export const trailersNotesHeader = [
	{
		settings: true,
		text: "Created date",
		value: "filter_created_date",
		func: false,
		sortable: false,
		model: { value: 'date' },
	},
	{
		settings: true,
		text: "Created by",
		value: "filter_created_by",
		func: false,
		sortable: false,
		model: { value: 'list' },
	},
	{
		settings: true,
		text: "Notes",
		value: "notes",
		sortable: false,
		model: { value: 'list' },
	}
];

export const trailerValueHeader = [
	{
		settings: true,
		text: "Created date",
		value: "createdDate",
		valueFilter: 'filter_createdDate',
		func: false,
		sortable: true,
		model: { value: 'date' },
	},
	{
		settings: true,
		text: "Created by",
		value: "createdBy",
		valueFilter: 'filter_createdBy',
		func: false,
		sortable: true,
		model: { value: 'list' },
	},
	{
		settings: true,
		text: "Period",
		value: "period",
		valueFilter: 'filter_period',
		sortable: true,
		func: false,
		model: { value: 'list' },
	},
	{
		settings: true,
		text: "Value for renewal",
		value: "renewal",
		valueFilter: 'filter_renewal',
		sortable: true,
		func: false,
		model: { value: 'list' },
	},
	{
		settings: true,
		text: "Notes",
		value: "note",
		valueFilter: 'filter_note',
		sortable: true,
		func: false,
		model: { value: 'note' },
	}
];

export const trailerEquipmentsHeader = [
	{
		settings: true,
		text: "Equipment",
		value: "filter_equipment",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
	},
	{
		settings: true,
		text: "Driver",
		value: "filter_driver",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
	},
	{
		settings: true,
		text: "Receiving date",
		value: "filter_receiving_date",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date', },
		left: false,
	},
	{
		settings: true,
		text: "Returned",
		value: "filter_returned",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false
	},
	{
		settings: true,
		text: "Returned date",
		value: "filter_returned_date",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date', },
		left: false,
	},
	{
		settings: true,
		text: "Notes",
		value: "filter_notes",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'note', },
		left: true,
	}
];

export const workOrdersHeader = [
	{
		settings: true,
		text: "ID",
		value: "filter_id",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Created date",
		value: "filter_create_at",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date', },
		left: false
	},
	{
		settings: true,
		text: "WO type",
		value: "filter_wo_type",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Arrived",
		value: "filter_arrived",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "ETA date",
		value: "filter_arrival_date",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date', },
		left: false
	},
	{
		settings: true,
		text: "Optional",
		value: "optional",
		func: true,
		filterable: false,
		sortable: false,
		model: { value: 'options', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Priority",
		value: "filter_dispatch_request",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'number', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Status",
		value: "filter_status",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false
	},
	{
		settings: true,
		text: "Check-in",
		value: "filter_check_in",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date', options: 'empty' },
		left: false
	},
	{
		settings: true,
		text: "Check-out",
		value: "filter_check_out",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date', options: 'empty' },
		left: false
	},
	{
		settings: true,
		text: "Fleet manager",
		value: "filter_technician",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: true
	},
	{
		settings: true,
		text: "Total",
		value: "filter_total",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'number', },
		left: true,
		dense: true
	}
];

export const billingHeader = [
	{
		settings: true,
		text: "Trip#",
		value: "trip_id",
		valueFilter: 'filter_trip_id',
		model: { value: 'list' },
		func: true,
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Load#",
		value: "load_id",
		valueFilter: 'filter_load_id',
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Route",
		value: "routs",
		valueFilter: 'filter_routs',
		model: { value: 'note' },
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "PU Date",
		value: "pick_up_datetime",
		valueFilter: 'filter_pick_up_datetime',
		model: { value: 'date' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "DEL Date",
		value: "delivery_datetime",
		valueFilter: 'filter_delivery_datetime',
		model: { value: 'date' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Customer",
		value: "customer",
		valueFilter: 'filter_customer',
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Broker name",
		value: "broker_name",
		valueFilter: 'filter_broker',
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Broker load #",
		value: "broker_number",
		valueFilter: 'filter_broker_number',
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Gross",
		value: "gross",
		valueFilter: 'filter_gross',
		model: { value: 'number' },
		func: true,
		sortable: true,
		dollar: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Dispatcher",
		value: "dispatcher",
		valueFilter: 'filter_dispatcher',
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "BOL (files)",
		value: "bol",
		valueFilter: 'filter_bol',
		model: { value: 'list' },
		func: true,
		sortable: true,
		align: 'center',
		isStatus: true,
	},
	{
		settings: true,
		text: "Invoice",
		value: "invoice",
		valueFilter: 'filter_invoice',
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Factoring",
		value: "factoring",
		valueFilter: 'filter_factoring',
		model: { value: 'list' },
		func: true,
		sortable: true,
		toLeft: true,
	},
	{
		settings: true,
		text: "PPW",
		value: "ppw_url",
		valueFilter: 'filter_ppw',
		model: { value: 'list' },
		func: true,
		sortable: true,
		ppw: true,
		toLeft: true,
		buttons: [
			{
				perm: true,
				value: 'send',
				text: 'Send PPW',
				icon: { value: 'icon_send', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'watchFiles',
				text: 'Veiw PPW',
				icon: { value: 'icon_view', w: 18, h: 14 },
			},
			{
				download: true,
				perm: true,
				value: 'download',
				text: 'Download',
				icon: { value: 'icon_download', w: 18, h: 18 },
			},
		],
	}
];

export const schedulesHeader = [
	{
		settings: true,
		text: "Id",
		value: "id",
		valueFilter: 'filter_id',
		func: true,
		model: { value: 'list' },
		sortable: true,
		footer: "count"
	},
	{
		settings: true,
		text: "Created date",
		value: "create_at",
		valueFilter: 'filter_created_date',
		func: true,
		model: { value: 'date' },
		sortable: true
	},
	{
		settings: true,
		text: "Created by",
		value: "created_by",
		valueFilter: 'filter_created_by',
		func: true,
		model: { value: 'list' },
		sortable: true,
		footer: "unique",
	},
	{
		settings: true,
		text: "Customer name",
		value: "name",
		valueFilter: 'filter_customer',
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Factoring company",
		value: "factoring",
		valueFilter: 'filter_factoring',
		func: true,
		model: { value: 'list' },
		sortable: true,
		footer: "unique",
	},
	{
		settings: true,
		text: "Loads",
		value: "load_count",
		valueFilter: 'filter_load_count',
		func: true,
		model: { value: 'number', },
		sortable: true,
		filterable: false,
		footer: "sum"
	},
	{
		settings: true,
		text: "Processed",
		value: "applied_load",
		valueFilter: 'filter_applied_load',
		func: true,
		model: { value: 'number' },
		sortable: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Not processed",
		value: "not_processed",
		valueFilter: 'filter_not_processed',
		func: true,
		model: { value: 'number' },
		sortable: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Gross",
		value: "gross",
		valueFilter: "filter_gross",
		func: true,
		model: { value: 'number' },
		sortable: true,
		toLeft: true,
		filterable: false,
		footer: "sum",
		dollar: true,
	},
	{
		settings: true,
		text: "Amount",
		value: "amount",
		valueFilter: "filter_amount",
		func: true,
		model: { value: 'number' },
		sortable: true,
		toLeft: true,
		filterable: false,
		footer: "sum",
		dollar: true,
	},
	{
		settings: true,
		buttons: [
			{
				perm: { or: [ 9, 8 ] },
				value: 'send',
				text: 'Send schedules to email',
				icon: { value: 'icon_send', w: 16, h: 16 },
			},
			{
				perm: { or: [ 9, 8 ] },
				value: 'visibility',
				text: 'View files',
				icon: { value: 'icon_view', w: 17, h: 14 },
			},
			{
				perm: { or: [ 9, 8 ] },
				value: 'save_alt',
				text: 'Save',
				icon: { value: 'icon_download', w: 16, h: 16 },
			},
		],
	},
];

export const shortPaymentsHeader = [
	{
		settings: true,
		text: "Load",
		value: "load_id",
		valueFilter: 'filter_id',
		func: true,
		model: { value: 'list', },
		sortable: true,
		footer: "count"
	},
	{
		settings: true,
		text: "Customer",
		value: "customer",
		valueFilter: 'filter_customer',
		func: true,
		model: { value: 'list', },
		sortable: true
	},
	{
		settings: true,
		text: "Broker name",
		value: "broker_name",
		valueFilter: 'filter_broker',
		func: true,
		model: { value: 'list', },
		sortable: true
	},
	{
		settings: true,
		text: "Broker load",
		value: "broker_number",
		valueFilter: 'filter_broker_number',
		func: true,
		model: { value: 'list', },
		sortable: true
	},
	{
		settings: true,
		text: "Factoring company",
		value: "factoring_name",
		valueFilter: 'filter_factoring_name',
		func: true,
		model: { value: 'list', },
		sortable: true
	},
	{
		settings: true,
		text: "Gross",
		value: "gross",
		valueFilter: 'filter_gross',
		func: true,
		model: { value: 'number', },
		filterable: false,
		sortable: true,
		footer: "sum",
		dollar: true,
	},
	{
		settings: true,
		text: "Amount",
		value: "amount_factoring",
		valueFilter: 'filter_amount_factoring',
		func: true,
		model: { value: 'number', },
		filterable: false,
		sortable: true,
		footer: "sum",
		dollar: true,
	},
	{
		settings: true,
		text: "Debt",
		value: "debt",
		valueFilter: 'filter_debt',
		func: true,
		model: { value: 'number', },
		filterable: false,
		sortable: true,
		footer: "sum",
		dollar: true,
	},
	{
		settings: true,
		text: "Processed date",
		value: "processed_date",
		valueFilter: 'filter_processed_date',
		func: true,
		model: { value: 'date', },
		sortable: true
	},
	{
		settings: true,
		text: "Age (days)",
		value: "age",
		valueFilter: 'filter_age',
		func: true,
		model: { value: 'number', },
		filterable: false,
		sortable: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Actions",
		value: "actions",
		valueFilter: 'filter_actions',
		func: true,
		model: { value: 'number', },
		filterable: false,
		sortable: true,
		toLeft: true,
		footer: "sum",
		buttonsValue: true,
		buttons: [
			{
				perm: {
					and: [ 9, 10 ]
				},
				value: 'actions',
				text: 'Actions',
				icon: { value: 'icon_history', w: 18, h: 18 },
			},
		],
	},

	{
		settings: true,
		text: "Status",
		value: "status",
		valueFilter: 'filter_status',
		func: true,
		model: { value: 'list', },
		sortable: true,
		toLeft: true
	},

];
export const shortPaymentsInfoModalHeader = [
	{
		text: "Age (days)",
		value: "text",
	},
	{
		text: 'Comment',
		value: 'description',
	}
];

export const shortPaymentsInfoModalContent = [
	{ age: 10, id: 1, text: "<30", description: "Payment verification is not required", },
	{ age: 50, id: 2, text: "30-60", description: "Payment requires verification", },
	{ age: 70, id: 3, text: ">60", description: "Urgent payment verification required", }
];

export const factoringHeader = [
	{
		settings: true,
		text: "ID",
		value: "id",
		valueFilter: 'filter_id',
		func: true,
		model: { value: 'list' },
		sortable: true,
		checkbox: false,
		footer: "unique"
	},
	{
		settings: true,
		text: "Factoring company name",
		value: "name",
		valueFilter: 'filter_name',
		func: true,
		model: { value: 'list' },
		sortable: true,
		checkbox: false,
	},
	{
		settings: true,
		text: "Phone",
		value: "phone",
		valueFilter: 'filter_phone',
		func: true,
		model: { value: 'list' },
		sortable: true,
		checkbox: false,
	},
	{
		settings: true,
		text: "Fax",
		value: "fax",
		valueFilter: 'filter_fax',
		func: true,
		model: { value: 'list' },
		sortable: true,
		checkbox: false,
	},
	{
		settings: true,
		text: "Adress",
		value: "address",
		func: true,
		valueFilter: 'filter_address',
		model: { value: 'note' },
		sortable: true,
		checkbox: false,
		toLeft: true
	},
	{
		settings: true,
		text: "City, state, ZIP",
		value: "city",
		func: true,
		valueFilter: 'filter_city',
		model: { value: 'list' },
		sortable: true,
		checkbox: false,
	},
	{
		settings: true,
		text: "Percent",
		value: "percent",
		func: true,
		valueFilter: 'filter_percent',
		model: { value: 'number' },
		sortable: true,
		checkbox: false,
		toLeft: true
	},
	{
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'delete',
				text: 'Delete',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];

export const customerPaymentsHeader = [
	{
		settings: true,
		text: "ID",
		value: "id",
		valueFilter: 'filter_id',
		func: true,
		model: { value: 'list' },
		sortable: true,
		footer: "count"
	},
	{
		settings: true,
		text: "Invoice id",
		value: "invoice_id",
		valueFilter: 'filter_invoice_id',
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Generated date",
		value: "invoice_create_at",
		valueFilter: 'filter_invoice_create_at',
		func: true,
		model: { value: 'date' },
		sortable: true,
		modValue: 'onlyDay'
	},
	{
		settings: true,
		text: "Customer",
		value: "customer",
		valueFilter: 'filter_customer',
		func: true,
		model: { value: 'list' },
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Invoice",
		value: "total_check",
		valueFilter: 'filter_total_check',
		func: true,
		model: { value: 'number' },
		sortable: true,
		footer: "sum",
		dollar: true,
	},
	{
		settings: true,
		text: "Payment date",
		value: "date",
		valueFilter: 'filter_date',
		func: true,
		model: { value: 'date' },
		sortable: true
	},
	{
		settings: true,
		text: "Amount",
		value: "amount",
		valueFilter: 'filter_amount',
		func: true,
		model: { value: 'number' },
		sortable: true,
		footer: "sum",
		dollar: true,

	},
	{
		settings: true,
		text: "Employee",
		value: "employee",
		valueFilter: 'filter_employee',
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Sales manager",
		value: "sales_manager",
		valueFilter: 'filter_sales_manager',
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Services",
		value: "services",
		valueFilter: 'filter_services',
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Payment method",
		value: "payment_method",
		valueFilter: 'filter_payment_method',
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Payment account",
		value: "payment_account",
		valueFilter: "filter_payment_account",
		func: true,
		sortable: true,
		model: { value: 'list' }
	},
	{
		settings: true,
		text: "Status",
		value: "invoice_status",
		valueFilter: 'filter_invoice_status',
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Note",
		value: "note",
		valueFilter: 'filter_note',
		func: true,
		model: { value: 'note' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		func: false,
		sortable: false,
		toLeft: true,
		buttons: [
			{
				perm: true,
				value: 'delete',
				text: 'Delete',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			},
		],
	},
];

export const reportHeader = [
	{
		settings: true,
		text: "ID",
		value: "id",
		valueFilter: "filter_id",
		model: { value: 'list' },
		func: true,
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Customer",
		value: "customer",
		valueFilter: "filter_customer",
		model: { value: 'list' },
		func: true,
		sortable: true
	},
	{
		settings: true,
		text: "From",
		value: "from",
		valueFilter: "filter_from",
		func: true,
		model: { value: 'date' },
		sortable: true
	},
	{
		settings: true,
		text: "To",
		value: "to",
		valueFilter: "filter_to",
		func: true,
		model: { value: 'date' },
		sortable: true
	},
	{
		settings: true,
		text: "Send to",
		value: "send_to",
		valueFilter: "filter_send_to",
		model: { value: 'list' },
		func: true,
		sortable: true
	},

	{
		settings: true,
		text: "Send by",
		value: "send_by",
		valueFilter: "filter_send_by",
		model: { value: 'list' },
		func: true,
		sortable: true
	},
	{
		settings: true,
		text: "Sent date",
		value: "sent_date",
		valueFilter: "filter_sent_date",
		model: { value: 'date' },
		func: true,
		sortable: true,
		toLeft: true,
	},
	{
		settings: true,
		buttons: [
			{
				perm: {
					and: [ 10 ]
				},
				value: 'file',
				text: 'View',
				icon: { value: 'icon_view', w: 18, h: 14 },
			},
			{
				download: true,
				perm: true,
				value: 'download',
				text: 'Download',
				icon: { value: 'icon_download', w: 18, h: 18 },
			},
			{
				perm: {
					and: [ 15 ]
				},
				value: 'send',
				text: 'Send',
				icon: { value: 'icon_send', w: 18, h: 18 },
			},
		]
	},
];

export const dispatchersStatementsHeader = [
	{
		settings: true,
		text: "ID",
		value: "id",
		valueFilter: 'filter_id',
		model: { value: 'list' },
		func: true,
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Created by",
		value: "created_by",
		valueFilter: 'filter_created_by',
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "End month date",
		value: "date",
		valueFilter: 'filter_date',
		model: { value: 'date' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Dispatcher",
		value: "dispatcher_name",
		valueFilter: 'filter_dispatcher_name',
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Gross",
		value: "gross",
		valueFilter: 'filter_gross',
		model: { value: 'number' },
		func: true,
		sortable: true,
		dollar: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Loads amount",
		value: "count_load",
		valueFilter: 'filter_count_load',
		func: true,
		model: { value: 'number' },
		sortable: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "RPM",
		value: "rpm",
		valueFilter: 'filter_rpm',
		func: true,
		model: { value: 'number' },
		sortable: true,
	},
	{
		settings: true,
		text: "Salary",
		value: "amount",
		valueFilter: 'filter_amount',
		func: true,
		model: { value: 'number' },
		sortable: true,
		dollar: true,
		toLeft: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Rate",
		value: "dispatcher_rate",
		valueFilter: 'dispatcher_rate',
		func: true,
		model: { value: 'number' },
		sortable: true,
		toLeft: true,
	},
	{
		settings: true,
		buttons: [
			{
				perm: { or: [ 10 ] },
				value: 'openLoads',
				text: 'St-t',
				icon: { value: 'icon_view', w: 17, h: 14 },
			},
			{
				perm: {
					or: [ 11 ]
				},
				value: 'delete',
				text: 'Delete',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			}
		]
	},
];
export const dispatchersStatementsHeaderUser = [
	{
		settings: true,
		text: "ID",
		value: "id",
		valueFilter: 'filter_id',
		model: { value: 'list' },
		func: true,
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Created by",
		value: "created_by",
		valueFilter: 'filter_created_by',
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "End month date",
		value: "date",
		valueFilter: 'filter_date',
		model: { value: 'date' },
		func: true,
		sortable: true,
	},
	// {
	// 	settings: true,
	// 	text: "Dispatcher",
	// 	value: "dispatcher_name",
	// 	valueFilter: 'filter_dispatcher_name',
	// 	model: { value: 'list' },
	// 	func: true,
	// 	sortable: true,
	// },
	{
		settings: true,
		text: "Gross",
		value: "gross",
		valueFilter: 'filter_gross',
		model: { value: 'number' },
		func: true,
		sortable: true,
		dollar: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Loads amount",
		value: "count_load",
		valueFilter: 'filter_count_load',
		func: true,
		model: { value: 'number' },
		sortable: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "RPM",
		value: "rpm",
		valueFilter: 'filter_rpm',
		func: true,
		model: { value: 'number' },
		sortable: true,
	},
	{
		settings: true,
		text: "Salary",
		value: "amount",
		valueFilter: 'filter_amount',
		func: true,
		model: { value: 'number' },
		sortable: true,
		dollar: true,
		toLeft: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Bonus",
		value: "bonus",
		valueFilter: 'filter_bonus',
		func: true,
		model: { value: 'number' },
		sortable: true,
		dollar: true,
		toLeft: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Total",
		value: "total",
		valueFilter: 'filter_total',
		func: true,
		model: { value: 'number' },
		sortable: true,
		dollar: true,
		toLeft: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Rate",
		value: "dispatcher_rate",
		valueFilter: 'dispatcher_rate',
		func: true,
		model: { value: 'number' },
		sortable: true,
		toLeft: true,
	},
	{
		settings: true,
		buttons: [
			{
				perm: { or: [ 10 ] },
				value: 'openLoads',
				text: 'St-t',
				icon: { value: 'icon_view', w: 17, h: 14 },
			},
			// {
			// 	perm: {
			// 		or: [ 11 ]
			// 	},
			// 	value: 'delete',
			// 	text: 'Delete 2',
			// 	icon: { value: 'deleteItem', w: 18, h: 18 },
			// }
		]
	},
];

export const dispatchersStatementsLoadHeader = [
	{
		settings: true,
		text: "Trip ID",
		value: "trip_id",
		valueFilter: "filter_trip_id",
		model: { value: 'list' },
		func: true,
		sortable: true,
		footer: "count"
	},
	{
		settings: true,
		text: "Load#",
		value: "load_id",
		valueFilter: "filter_load_id",
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Truck#",
		value: "truck",
		valueFilter: "filter_truck",
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Trailer#",
		value: "trailer",
		valueFilter: "filter_trailer",
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Trailer Type",
		value: "trailer_type",
		valueFilter: "filter_trailer_type",
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Customer",
		value: "customer",
		valueFilter: "filter_customer",
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Broker",
		value: "broker_name",
		valueFilter: "filter_broker_name",
		model: { value: 'list' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "Route",
		value: "routs",
		valueFilter: "filter_routs",
		model: { value: 'note' },
		func: true,
		sortable: true,
	},
	{
		settings: true,
		text: "PU Date",
		value: "pick_up_datetime",
		valueFilter: "filter_pick_up_datetime",
		func: true,
		model: { value: 'date' },
		sortable: true,
	},
	{
		settings: true,
		text: "Delivery Date",
		value: "delivery_datetime",
		valueFilter: "filter_delivery_datetime",
		func: true,
		model: { value: 'date' },
		sortable: true,
	},
	{
		settings: true,
		text: "Gross",
		value: "gross",
		valueFilter: "filter_gross",
		func: true,
		model: { value: 'number' },
		sortable: true,
		dollar: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Total miles",
		value: "pick_up_mileage",
		valueFilter: "filter_pick_up_mileage",
		func: true,
		model: { value: 'number' },
		sortable: true,
	},
	{
		settings: true,
		text: "RPM",
		value: "rpm",
		valueFilter: "filter_rpm",
		func: true,
		model: { value: 'number' },
		sortable: true,
	},
	{
		settings: true,
		text: "Rate",
		value: "dispatcher_rate",
		valueFilter: "filter_dispatcher_rate",
		func: true,
		model: { value: 'number' },
		sortable: true,
		toLeft: true,
	},
];

export const dispatchersStatementsCreateHeader = [
	{
		settings: true,
		text: "Salary Pay",
		value: "salary_pay",
		valueFilter: "filter_salary_pay",
		model: { value: 'list' },
		func: false,
		sortable: false,
		checkbox: true,
		checkboxAll: true,
		footer: "count"
	},
	{
		settings: true,
		text: "Dispatcher",
		value: "personal_name",
		valueFilter: "filter_personal_name",
		model: { value: 'list' },
		func: true,
		sortable: true
	},
	{
		settings: true,
		text: "Bonus",
		value: "bonus",
		valueFilter: "filter_bonus",
		func: true,
		model: { value: 'number' },
		sortable: true,
		dollar: true,
		toLeft: true,
	},
	{
		settings: true,
		text: "Base rate",
		value: "base_rate",
		valueFilter: "filter_base_rate",
		func: true,
		model: { value: 'number' },
		sortable: true,
		dollar: true
	},
	{
		settings: true,
		text: "Gross",
		value: "gross",
		valueFilter: "filter_gross",
		func: true,
		model: { value: 'number' },
		sortable: true,
		dollar: true
	},
	{
		settings: true,
		text: "Salary",
		value: "salary",
		valueFilter: "filter_salary",
		func: true,
		model: { value: 'number' },
		sortable: true,
		dollar: true,
		toLeft: true,
	},

	{
		settings: true,
		text: "Rate",
		value: "dispatcher_rate",
		valueFilter: "filter_dispatcher_rate",
		func: true,
		model: { value: 'number' },
		sortable: true,
		toLeft: true,
	},
	{
		settings: true,
		text: "Total",
		value: "total",
		valueFilter: "filter_total",
		func: true,
		model: { value: 'number' },
		sortable: true,
		dollar: true,
		toLeft: true,
	},
	{
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'openLoads',
				text: 'St-t',
				icon: { value: 'icon_view', w: 17, h: 14 },
			}
		]
	},
];

export const dispatchersStatementsCreateUpHeader = [
	{
		settings: true,
		text: "Month",
		value: "month",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Dispatcher",
		value: "personal_name",
		func: false,
		sortable: true,
	},
	{
		settings: true,
		text: "Bonus",
		value: "bonus",
		func: false,
		sortable: true,
		dollar: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Charge",
		value: "charge",
		func: false,
		sortable: true,
		dollar: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Gross",
		value: "gross",
		func: false,
		sortable: true,
		dollar: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Salary",
		value: "salary",
		func: false,
		sortable: true,
		dollar: true,
		toLeft: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Base",
		value: "dispatcher_salary",
		func: false,
		sortable: true,
		dollar: true,
		toLeft: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Total",
		value: "total",
		func: false,
		sortable: true,
		dollar: true,
		footer: "sum"
	},
	{
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'openLoads',
				text: 'St-t',
				icon: { value: 'icon_view', w: 17, h: 14 },
			}
		]
	},
];

export const workOrdersListHeader = [
	{
		settings: true,
		text: "ID",
		value: "id",
		valueFilter: "filter_id",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true,
		footer: "count"
	},
	{
		settings: true,
		text: "Created date",
		value: "create_at",
		valueFilter: "filter_create_at",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date' },
		left: false
	},
	{
		settings: true,
		text: "WO type",
		value: "wo_type",
		valueFilter: "filter_wo_type",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Unit type",
		value: "unit_type",
		valueFilter: "filter_unit_type",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "Unit#",
		value: "unit",
		valueFilter: "filter_unit",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "Arrived",
		value: "arrived",
		valueFilter: "filter_arrived",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true,
		align: 'center',
		isStatus: true,
	},
	{
		settings: true,
		text: "ETA date",
		value: "arrival_date",
		valueFilter: "filter_arrival_date",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date' },
		left: false
	},
	{
		settings: true,
		text: "Optional",
		value: "optional",
		valueFilter: "optional",
		func: true,
		filterable: false,
		sortable: false,
		model: { value: 'options' },
		left: false,
		dense: true,
		align: 'center',
		icons: [
			{ w: 25, h: 24, id: 'alignment', value: 'option_alignment' },
			{ w: 25, h: 24, id: 'inspection', value: 'option_inspection' },
			{ w: 25, h: 24, id: 'pm', value: 'option_pm' },
			{ w: 25, h: 24, id: 'towing', value: 'option_towing' },
		]
	},
	{
		settings: true,
		text: "Priority",
		value: "dispatch_request",
		valueFilter: "filter_dispatch_request",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'number' },
		left: false,
		dense: true,
		align: 'center',
		counter: true
	},
	{
		settings: true,
		text: "Status",
		value: "status",
		valueFilter: "filter_status",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		statusColor: true,
	},
	{
		settings: true,
		text: "Check-in",
		value: "check_in",
		valueFilter: "filter_check_in",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date', options: 'empty' },
		left: false
	},
	{
		settings: true,
		text: "Check-out",
		value: "check_out",
		valueFilter: "filter_check_out",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date', options: 'empty' },
		left: false
	},
	{
		settings: true,
		text: "Fleet manager",
		value: "technician",
		valueFilter: "filter_technician",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: true
	},
	{
		settings: true,
		text: "Total",
		value: "total",
		valueFilter: "filter_total",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'number' },
		left: true,
		dense: true,
		dollar: true,
		footer: "sum"
	},
	{
		settings: true,
		func: false,
		sortable: false,
		toLeft: true,
		buttons: [
			{
				perm: true,
				value: 'delete',
				text: 'Delete',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			},
		],
	},
];

export const tripsListHeader = [
	{
		settings: true,
		childElements: 'Parent'
	},
	{
		settings: true,
		text: "ID",
		value: "trip_id",
		childValue: "load_id",
		valueFilter: "filter_trip_id",
		func: true,
		sortable: true,
		model: { value: 'note', type: 'number' },
		nowrap: true,
		modText: true,
		totalMod: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Broker",
		value: "broker_name",
		valueFilter: "filter_broker_name",
		func: true,
		sortable: true,
		model: { value: 'list' },
	},
	{
		settings: true,
		text: "Broker load",
		value: "broker_number",
		valueFilter: "filter_broker_number",
		func: true,
		sortable: true,
		nowrap: true,
		model: { value: 'list' },
	},
	{
		settings: true,
		text: "Customer",
		value: "customer",
		childValue: "сarrier",
		valueFilter: "filter_customer",
		func: true,
		sortable: true,
		model: { value: 'list' },
		footer: "unique"
	},
	{
		settings: true,
		text: "Truck",
		value: "truck",
		valueFilter: "filter_truck",
		func: true,
		sortable: true,
		model: { value: 'list' },
		nowrap: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Trailer",
		value: "trailer",
		valueFilter: "filter_trailer",
		func: true,
		sortable: true,
		model: { value: 'list' },
		nowrap: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Trailer type",
		value: "trailer_type",
		valueFilter: "filter_trailer_type",
		func: true,
		sortable: true,
		model: { value: 'list' },
	},
	{
		settings: true,
		text: "Driver name",
		value: "driver",
		valueFilter: "filter_driver",
		func: true,
		sortable: true,
		model: { value: 'list' },
		footer: "unique"
	},
	{
		settings: true,
		text: "Dispatcher",
		value: "dispatcher",
		valueFilter: "filter_dispatcher",
		func: true,
		sortable: true,
		model: { value: 'list' },
		footer: "unique"
	},
	{
		settings: true,
		text: "Route",
		value: "routs",
		valueFilter: "filter_routs",
		func: true,
		sortable: true,
		model: {
			value: 'address',
			filters: [
				{ filter: "filter_rout_state", label: "Select state" },
				{ filter: "filter_rout_city", label: "Select city" },
			]
		},
	},
	{
		settings: true,
		text: "Gross",
		value: "gross",
		valueFilter: "filter_gross",
		func: true,
		sortable: true,
		model: { value: 'number' },
		nowrap: true,
		dollar: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "RPM",
		value: "rpm",
		valueFilter: "filter_rpm",
		func: true,
		sortable: true,
		model: { value: 'number' },
		nowrap: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Total miles",
		value: "mileage_total",
		valueFilter: "filter_mileage_total",
		func: true,
		sortable: true,
		model: { value: 'number' },
		miles: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Loaded miles",
		value: "pick_up_mileage",
		valueFilter: "filter_pick_up_mileage",
		func: true,
		sortable: true,
		model: { value: 'number' },
		miles: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Empty miles",
		value: "mileage_empty",
		valueFilter: "filter_mileage_empty",
		func: true,
		sortable: true,
		model: { value: 'number' },
		miles: true,
		footer: "sum"
	},
	{
		settings: true,
		text: "Pickup date",
		value: "pick_up_datetime",
		valueFilter: "filter_pick_up_datetime",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date' },
	},
	{
		settings: true,
		text: "Delivery date",
		value: "delivery_datetime",
		valueFilter: "filter_delivery_datetime",
		func: true,
		sortable: true,
		model: { value: 'date' },
	},
	{
		settings: true,
		text: "Created at",
		value: "created_at",
		valueFilter: "filter_created_at",
		func: true,
		sortable: true,
		model: { value: 'date' },
	},
	{
		settings: true,
		text: "Customer invoice #",
		value: "customer_invoice",
		valueFilter: "filter_customer_invoice",
		func: true,
		sortable: true,
		model: { value: 'list' },
		toLeft: true,
	},
	{
		settings: true,
		text: "Dispatch st-t#",
		value: "dispatcher_statement",
		valueFilter: "filter_dispatcher_statement",
		func: true,
		sortable: true,
		model: { value: 'list' },
		toLeft: true,
	},
	{
		settings: true,
		text: "By Ai",
		value: "ai_status",
		valueFilter: "filter_ai_status",
		func: true,
		sortable: true,
		model: { value: 'list' },
		toLeft: true,
		align: 'center',
		isStatus: true,
	},
	{
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'download',
				text: 'Download files',
				icon: { value: 'icon_download', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'edit',
				text: 'Edit',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'view',
				text: 'View',
				icon: { value: 'icon_view', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete',
				text: 'Delete',
				icon: { value: 'deleteItem', w: 20, h: 20 },
			}
		]
	},
];

export const tripsChildrenListHeader = [
	{
		settings: true,
		childElements: 'Child'
	},
	{
		settings: true,
		text: "ID",
		value: "load_id",
		valueFilter: "filter_trip_id",
		func: true,
		sortable: true,
		model: { value: 'list' },
		nowrap: true,
		modText: true,
	},
	{
		settings: true,
		text: "Broker",
		value: "broker_name",
		valueFilter: "filter_broker_name",
		func: true,
		sortable: true,
		model: { value: 'list' },
	},
	{
		settings: true,
		text: "Broker load",
		value: "broker_number",
		valueFilter: "filter_broker_number",
		func: true,
		sortable: true,
		model: { value: 'list' },
	},
	{
		settings: true,
		text: "Customer",
		value: "сarrier",
		valueFilter: "filter_customer",
		func: true,
		sortable: true,
		model: { value: 'list' },
	},
	{
		settings: true,
		text: "Truck",
		value: "truck",
		valueFilter: "filter_truck",
		func: true,
		sortable: true,
		model: { value: 'list' },
	},
	{
		settings: true,
		text: "Trailer",
		value: "trailer",
		valueFilter: "filter_trailer",
		func: true,
		sortable: true,
		model: { value: 'list' },
	},
	{
		settings: true,
		text: "Trailer type",
		value: "trailer_type",
		valueFilter: "filter_trailer_type",
		func: true,
		sortable: true,
		model: { value: 'list' },
	},
	{
		settings: true,
		text: "Driver name",
		value: "driver",
		valueFilter: "filter_driver",
		func: true,
		sortable: true,
		model: { value: 'list' },
	},
	{
		settings: true,
		text: "Dispatcher",
		value: "dispatcher",
		valueFilter: "filter_dispatcher",
		func: true,
		sortable: true,
		model: { value: 'list' },
	},
	{
		settings: true,
		text: "Route",
		value: "routs",
		valueFilter: "filter_routs",
		func: true,
		sortable: true,
		model: { value: 'address' },
	},
	{
		settings: true,
		text: "Gross",
		value: "gross",
		valueFilter: "filter_gross",
		func: true,
		sortable: true,
		nowrap: true,
		dollar: true,
		model: { value: 'number' },
	},
	{
		settings: true,
		text: "RPM",
		value: "rpm",
		valueFilter: "filter_rpm",
		func: true,
		sortable: true,
		model: { value: 'number' },
	},
	{
		settings: true,
		text: "Total miles",
		value: "mileage_total",
		valueFilter: "filter_mileage_total",
		func: true,
		sortable: true,
		model: { value: 'number' },
		miles: true
	},
	{
		settings: true,
		text: "Loaded miles",
		value: "pick_up_mileage",
		valueFilter: "filter_pick_up_mileage",
		func: true,
		sortable: true,
		model: { value: 'number' },
		miles: true
	},
	{
		settings: true,
		text: "Empty miles",
		value: "mileage_empty",
		valueFilter: "filter_mileage_empty",
		func: true,
		sortable: true,
		model: { value: 'number' },
		miles: true
	},
	{
		settings: true,
		text: "PickupDelivery date",
		value: "pick_up_datetime",
		valueFilter: "filter_pick_up_datetime",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date' },
	},
	{
		settings: true,
		text: "Delivery date",
		value: "delivery_datetime",
		valueFilter: "filter_delivery_datetime",
		func: true,
		sortable: true,
		model: { value: 'date' },
	},
	{
		settings: true,
		text: "Created at",
		value: "created_at",
		valueFilter: "filter_created_at",
		func: true,
		sortable: true,
		model: { value: 'date' },
	},
	{
		settings: true,
		text: "Customer invoice#",
		value: "customer_invoice",
		valueFilter: "filter_customer_invoice",
		func: true,
		sortable: true,
		model: { value: 'list' },
		toLeft: true,
	},
	{
		settings: true,
		text: "Dispatcher statement#",
		value: "dispatcher_statement",
		valueFilter: "filter_dispatcher_statement",
		func: true,
		sortable: true,
		model: { value: 'list' },
		toLeft: true,
	},
	{
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'edit',
				text: 'Edit',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete',
				text: 'Delete',
				icon: { value: 'deleteItem', w: 20, h: 20 },
			}
		]
	},
];

export const driverContractHeader = [
	{
		settings: true,
		text: "Date created",
		value: "filter_create_at",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date' }
	},
	{
		settings: true,
		text: "Created by",
		value: "filter_created_by",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' }
	},
	{
		settings: true,
		text: "Status",
		value: "filter_status",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "Start date",
		value: "filter_date_start",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date' }
	},
	{
		settings: true,
		text: "End date",
		value: "filter_date_end",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date' }
	},
	{
		settings: true,
		text: "Contract type",
		value: "filter_contract_type",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' }
	},
	{
		settings: true,
		text: "Contract ID",
		value: "filter_id",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "File name",
		value: "filter_file_name",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: true
	}
];

export const statisticInfoHeader = [
	{
		settings: true,
		text: "Unit",
		value: "filter_unit",
		valueFilter: 'unit',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Work order #",
		value: "filter_id",
		valueFilter: 'id',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "WO type",
		value: "filter_wo_type",
		valueFilter: 'type',
		func: false,
		filterable: false,
		sortable: false,
		model: { value: 'list', },
		left: false
	},
	{
		settings: true,
		text: "Requested date",
		value: "filter_request_date",
		valueFilter: 'request_date',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date', options: 'empty' },
		left: false
	},
	{
		settings: true,
		text: "Arrived date",
		value: "filter_arrival_date",
		valueFilter: 'arrival_date',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date', options: 'empty' },
		left: false
	},
	{
		settings: true,
		text: "Checkout date",
		value: "filter_check_out",
		valueFilter: 'check_out',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date', options: 'empty' },
		left: false
	}
];

export const motivationHeader = [
	{
		settings: true,
		text: "Unit#",
		value: "filter_truck_number",
		label: "Select truck number",
		valueFilter: 'truck_number',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Company owned",
		value: "filter_company_owned",
		label: "Select company owned",
		valueFilter: 'company_owned',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Company",
		value: "filter_customer",
		valueFilter: 'customer',
		label: "Select customer",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "Driver name",
		value: "filter_driver",
		label: "Select driver",
		valueFilter: 'driver',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "Driver type",
		value: "filter_driver_type",
		label: "Select driver type",
		valueFilter: 'driver_type',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "Reason",
		value: "filter_reason",
		label: "Select reason",
		valueFilter: 'reason',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', groups: true },
		left: false
	},
	{
		settings: true,
		text: "Description",
		value: "filter_description",
		label: "Select description",
		valueFilter: 'description',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'note' },
		left: false
	}
];

export const trucksRoadHeader = [
	{
		settings: true,
		text: "Id",
		value: "filter_id",
		valueFilter: 'id',
		label: "Select id",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "Date",
		value: "filter_date",
		label: "Select date",
		valueFilter: 'date',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'date' },
		left: false
	},
	{
		settings: true,
		text: "Truck#",
		value: "filter_truck_number",
		label: "Select truck number",
		valueFilter: 'truck_number',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Company owned",
		value: "filter_company_owned",
		label: "Select company owned",
		valueFilter: 'company_owned',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Company",
		value: "filter_customer",
		valueFilter: 'customer',
		label: "Select customer",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "Driver name",
		value: "filter_driver",
		label: "Select driver",
		valueFilter: 'driver',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "Driver type",
		value: "filter_driver_type",
		label: "Select driver type",
		valueFilter: 'driver_type',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "Reason",
		value: "filter_reason",
		label: "Select reason",
		valueFilter: 'reason',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list', groups: true },
		left: false
	},
	{
		settings: true,
		text: "Description",
		value: "filter_description",
		label: "Select description",
		valueFilter: 'description',
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'note' },
		left: false
	}
];

export const repairsHeader = [
	{
		settings: true,
		text: "Created date",
		value: "create_date",
		valueFilter: 'filter_create_date',
		func: false,
		model: { value: 'date' },
		sortable: false,
	},
	{
		settings: true,
		text: "Created by",
		value: "filter_created_by",
		func: false,
		filterable: false,
		sortable: false,
		model: { value: 'list' }
	},
	{
		settings: true,
		text: "Description",
		value: "filter_description",
		label: "Select description",
		valueFilter: 'description',
		func: false,
		filterable: false,
		sortable: false,
		model: { value: 'note' },
		left: false
	}
];

export const planerWorkOrdersHeader = [
	{
		settings: true,
		text: "WO",
		value: "wo_type",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'date', },
		left: false
	},
	{
		settings: true,
		text: "Customer",
		value: "customer",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "WO#",
		value: "id",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Unit type",
		value: "unit_type",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false
	},
	{
		settings: true,
		text: "Unit#",
		value: "unit",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false
	},
	{
		settings: true,
		text: "Priority",
		value: "priority",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'number', },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Status",
		value: "status",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list', },
		left: false
	}
];

export const driverHeader = [
	{
		settings: true,
		text: "Name",
		value: "name",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Contract type",
		value: "contract_type",
		func: false,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true
	}
];

export const newOrdersHeader = [
	{
		settings: true,
		text: "ID",
		value: "filter_id",
		valueFilter: "id",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true,
		footer: "count"
	},
	{
		settings: true,
		text: "Unit type",
		value: "filter_unit_type",
		valueFilter: "unit_type",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "Unit#",
		value: "filter_unit",
		valueFilter: "unit",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false
	},
	{
		settings: true,
		text: "Arrived",
		value: "filter_arrived",
		valueFilter: "arrived",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true,
		align: 'center',
		isStatus: true,
	},
	{
		settings: true,
		text: "Priority",
		value: "filter_dispatch_request",
		valueFilter: "dispatch_request",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'number' },
		left: false,
		dense: true,
		align: 'center',
		counter: true
	}
];

export const fuelHeader = [
	{
		settings: true,
		text: "Fueling date",
		value: "fueling_date",
		valueFilter: 'filter_fueling_date',
		func: true,
		model: { value: 'date' },
		sortable: true
	},
	{
		settings: true,
		text: "Truck #",
		value: "filter_truck",
		valueFilter: "truck",
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Location",
		value: "filter_location",
		valueFilter: "location",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Gallons",
		value: "filter_gallons",
		valueFilter: "gallons",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'number' },
		left: false,
		dense: true,
		footer: "count"
	},
	{
		settings: true,
		text: "Amount",
		value: "filter_amount",
		valueFilter: "amount",
		func: true,
		model: { value: 'number' },
		sortable: true,
		toLeft: true,
		footer: "count"
	},
];

export const additionPaymentsHeader = [
	{
		settings: true,
		text: "Payment id",
		value: "filter_id",
		valueFilter: "id",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true,
		footer: "count"
	},
	{
		settings: true,
		text: "Description",
		value: "filter_description",
		valueFilter: 'description',
		model: { value: 'note' },
		func: true,
		sortable: true,
		toLeft: true,
		align: 'center',
		counter: true
	},
	{
		settings: true,
		text: "Amount",
		value: "filter_amount",
		valueFilter: "amount",
		func: true,
		model: { value: 'number' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		text: "Created date",
		value: "created_at",
		valueFilter: 'filter_created_at',
		func: true,
		model: { value: 'date' },
		sortable: true
	},
	{
		settings: true,
		text: "Created by",
		value: "created_by",
		valueFilter: 'filter_created_by',
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Category",
		value: "filter_category",
		valueFilter: "category",
		func: true,
		model: { value: 'list' },
		sortable: true
	},
];
export const detailsPaymentsHeader = [
	{
		settings: true,
		text: "ID",
		value: "filter_id",
		valueFilter: "id",
		func: true,
		filterable: false,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true,
		footer: "count"
	},
	{
		settings: true,
		text: "Customer",
		value: "filter_customer",
		valueFilter: "customer",
		func: true,
		sortable: true,
		model: { value: 'list' },
		left: false,
		dense: true
	},
	{
		settings: true,
		text: "Driver",
		value: "filter_driver",
		valueFilter: "driver",
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Truck",
		value: "filter_truck",
		valueFilter: "truck",
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Amount",
		value: "filter_amount",
		valueFilter: "amount",
		func: true,
		model: { value: 'number' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		text: "Category",
		value: "filter_category",
		valueFilter: "category",
		func: true,
		model: { value: 'list' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		text: "Description",
		value: "filter_description",
		valueFilter: 'description',
		model: { value: 'note' },
		func: true,
		sortable: true,
		toLeft: true,
		align: 'center',
		counter: true
	},
	{
		settings: true,
		text: "",
		value: "pay",
		valueFilter: 'filter_pay',
		model: { value: 'list' },
		func: false,
		sortable: false,
		toLeft: true,
		align: 'center',
		counter: true
	}
];

export const driverStatementsHeader = [
	{
		settings: true,
		text: "Id",
		value: "id",
		valueFilter: 'filter_id',
		func: true,
		model: { value: 'list' },
		sortable: true,
		footer: "count",
	},
	{
		settings: true,
		text: "Created date",
		value: "date_at",
		valueFilter: 'filter_date_at',
		func: true,
		model: { value: 'date' },
		sortable: true,
	},
	{
		settings: true,
		text: "Paid date",
		value: "paid_data",
		valueFilter: 'filter_paid_data',
		func: true,
		model: { value: 'date' },
		sortable: true,
	},
	{
		settings: true,
		text: "Created by",
		value: "created_by",
		valueFilter: 'filter_created_by',
		func: true,
		model: { value: 'list' },
		sortable: true,
		footer: "unique",
	},
	{
		settings: true,
		text: "Customer",
		value: "customer",
		valueFilter: 'filter_customer',
		func: true,
		model: { value: 'list' },
		sortable: true,
		footer: "unique",
	},
	{
		settings: true,
		text: "Driver",
		value: "driver",
		valueFilter: 'filter_driver',
		func: true,
		model: { value: 'list' },
		sortable: true,
		footer: "unique",
	},
	{
		settings: true,
		text: "Contract type",
		value: "contract_type",
		valueFilter: 'filter_contract_type',
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "St-t status",
		value: "status",
		valueFilter: 'filter_status',
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Paid status",
		value: "paid_status",
		valueFilter: 'filter_paid_status',
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "St-t amount",
		value: "statements_amount",
		valueFilter: 'filter_statements_amount',
		func: true,
		model: { value: 'number', },
		sortable: true,
		filterable: false,
		footer: "sum",
		sum: true
	},
	{
		settings: true,
		text: "Paid amount",
		value: "paid_amount",
		valueFilter: 'filter_paid_amount',
		func: true,
		model: { value: 'number', },
		sortable: true,
		filterable: false,
		footer: "sum",
		sum: true
	},
	{
		settings: true,
		text: "Paid",
		value: "paid",
		valueFilter: 'filter_paid',
		func: true,
		model: { value: 'list', },
		sortable: true,
		filterable: false,
		isPay: true
	},
	{
		settings: true,
		buttons: [
			{
				perm: true,
				value: 'edit',
				text: 'Edit',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				value: 'delete',
				text: 'Delete',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			},
		],
	},
];

export const logbookListHeader = [
	{
		settings: true,
		text: "Date",
		value: "date",
		func: true,
		valueFilter: "filter_date",
		model: { value: 'date' },
		sortable: true,
		nowrap: true
	},
	{
		settings: true,
		text: "Customer",
		value: "customer_name",
		func: true,
		valueFilter: "filter_customer",
		model: { value: 'list' },
		sortable: true,
		modValue: "isCustomerLink"
	},
	{
		settings: true,
		text: "Driver name",
		value: "driver_name",
		func: true,
		valueFilter: "filter_driver",
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "ELD",
		value: "eld_count",
		func: true,
		valueFilter: "filter_eld",
		model: { value: 'list' },
		sortable: true,
		align: 'center',
		modValue: 'isCount'
	},
	/*{
		settings: true,
		text: "Eld name & access",
		value: "eld_name",
		func: true,
		valueFilter: "filter_eld",
		model: { value: 'list' },
		sortable: true,
		isButtonsWithLink: true,
		linkClassic: 'eld_url',
		buttons: [
			{
				perm: true,
				value: 'eld_login',
				text: 'Click to copy ELD login',
				icon: { value: 'user', w: 20, h: 20 },
				copied: true,
				copiedSuccess: 'Login copied',
			},
			{
				perm: true,
				value: 'eld_password',
				text: 'Click to copy ELD password',
				icon: { value: 'lock', w: 20, h: 20 },
				copied: true,
				copiedSuccess: 'Password copied',
			}
		]
	},*/
	{
		settings: true,
		text: "Driver phone",
		value: "driver_phone",
		func: true,
		valueFilter: "filter_phone",
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: false,
		text: "Driver phone 2",
		value: "driver_phone2",
		func: true,
		valueFilter: "filter_phone2",
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "Driver notes",
		value: "driver_notes",
		func: true,
		valueFilter: "filter_driver_notes",
		model: { value: 'note' },
		sortable: true,
		modValue: "isInputCell"

	},
	{
		settings: true,
		text: "Sale manager",
		value: "sale_manager",
		func: true,
		valueFilter: "filter_sale_manager",
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: false,
		text: "Truck",
		value: "truck",
		func: true,
		valueFilter: "filter_truck",
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: false,
		text: "Trailer",
		value: "trailer",
		func: true,
		valueFilter: "filter_trailer",
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: false,
		text: "Trailer type",
		value: "trailer_type",
		func: true,
		valueFilter: "filter_trailerType",
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "Service safety",
		value: "status_serves",
		valueFilter: 'filter_status_serves',
		model: { value: 'list' },
		func: true,
		sortable: true,
		align: 'center',
		isStatus: true,
	},
	{
		settings: true,
		text: "Employees",
		value: "employees",
		func: true,
		valueFilter: "filter_employee",
		model: { value: 'list' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		text: "Requests",
		value: "request",
		func: true,
		valueFilter: "filter_request",
		model: { value: 'list' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		text: "Actions",
		value: "action_count",
		valueFilter: 'filter_action_count',
		func: true,
		model: { value: 'number' },
		filterable: false,
		sortable: true,
		toLeft: true,
		footer: "sum",
		buttonsValue: true,
		buttons: [
			{
				perm: {
					and: [ 9, 10 ]
				},
				value: 'actions',
				text: 'Actions',
				icon: { value: 'icon_history', w: 18, h: 18 },
			},
		],
	},
];

export const logbookHeader = [
	{ settings: true, label: "date", text: "Date", value: "filter_date", func: true, model: 'date', sortable: true },
	{
		settings: true,
		label: "customer name",
		text: "Customer name",
		value: "filterCustomer",
		func: true,
		model: 'list',
		sortable: true
	},
	{
		settings: true,
		label: "driver name",
		text: "Driver name",
		value: "filterDriver",
		func: true,
		model: 'list',
		sortable: true
	},
	{
		settings: true,
		label: "eld name",
		text: "Eld name",
		value: "filterEld",
		func: true,
		model: 'list',
		sortable: true
	},
	{
		settings: true,
		label: "eld access",
		text: "Eld access",
		value: "filterEld",
		func: false,
		model: 'list',
		sortable: false
	},
	{
		settings: true,
		label: "driver phone",
		text: "Driver phone",
		value: "filterPhone",
		func: true,
		model: 'list',
		sortable: true
	},
	{ settings: true, label: "truck", text: "Truck", value: "filterTruck", func: true, model: 'list', sortable: true },
	{
		settings: true,
		label: "trailer",
		text: "Trailer",
		value: "filterTrailer",
		func: true,
		model: 'list',
		sortable: true
	},
	{
		settings: true,
		label: "trailer type",
		text: "Trailer type",
		value: "filterTrailerType",
		func: true,
		model: 'list',
		sortable: true
	},
	{
		settings: true,
		label: "service safety",
		text: "Service safety",
		value: "filter_status_serves",
		func: true,
		model: 'list',
		sortable: true
	},
	/*{text: "On duty", value: "notes", func: false, filterable: false, sortable: false, model: 'list'},*/
	{
		settings: true,
		label: "employees",
		text: "Employees",
		value: "filterEmployee",
		func: true,
		filterSplit: true,
		model: 'list',
		sortable: true
	},
	{
		settings: true,
		text: "Actions",
		value: "filter_action_count",
		func: true,
		filterable: true,
		sortable: true,
		toLeft: true,
		model: 'number'
	},
];

export const lostPaymentHeaders = [
	{
		settings: true,
		text: "ID",
		value: "id",
		valueFilter: 'filter_id',
		func: true,
		model: { value: 'list' },
		sortable: true,
		footer: "count"
	},
	{
		settings: true,
		text: "Invoice id",
		value: "invoice_id",
		valueFilter: 'filter_invoice_id',
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Date",
		value: "date",
		valueFilter: 'filter_date',
		func: true,
		model: { value: 'date' },
		sortable: true
	},
	{
		settings: true,
		text: "Customer",
		value: "customer",
		valueFilter: 'filter_customer',
		func: true,
		model: { value: 'list' },
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Mistake",
		value: "mistake",
		valueFilter: "filter_mistake",
		func: true,
		sortable: true,
		model: { value: 'list' },
		modValue: 'lostType',
	},

	{
		settings: true,
		text: "Loss",
		value: "loss",
		valueFilter: "filter_loss",
		func: true,
		sortable: true,
		model: { value: 'list' },
		modValue: 'lostType',
	},
	{
		settings: true,
		text: "Amount",
		value: "lost_amount",
		valueFilter: 'filter_lost_amount',
		func: true,
		model: { value: 'number' },
		sortable: true,
		footer: "sum",
		dollar: true,

	},
	{
		settings: true,
		text: "Employee",
		value: "employee",
		valueFilter: 'filter_employee',
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Sales manager",
		value: "sales_manager",
		valueFilter: 'filter_sales_manager',
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Services",
		value: "services",
		valueFilter: 'filter_services',
		func: true,
		model: { value: 'list' },
		sortable: true
	},
	{
		settings: true,
		text: "Note",
		value: "lost_notes",
		valueFilter: 'filter_lost_notes',
		func: true,
		model: { value: 'note' },
		sortable: true,
		toLeft: true
	},
	{
		settings: true,
		func: false,
		sortable: false,
		toLeft: true,
		buttons: [
			{
				perm: true,
				value: 'delete',
				text: 'Delete',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			},
		],
	},
];

export const customerInvoiceItemsHeaders = [
	{
		settings: true,
		text: "ID",
		value: "invoice_id",
		valueFilter: 'filter_invoice_id',
		func: true,
		model: { value: 'list' },
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Customer name",
		value: "customer",
		valueFilter: 'filter_customer',
		func: true,
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "Created date",
		value: "create_at",
		valueFilter: 'filter_create_at',
		func: true,
		model: { value: 'date' },
		sortable: true,
		modValue: 'dateTime'
	},
	{
		settings: true,
		text: "Created by",
		value: "created_by",
		valueFilter: 'filter_created_by',
		func: true,
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "Invoice date from",
		value: "from",
		valueFilter: 'filter_from',
		func: true,
		model: { value: 'date' },
		sortable: true,
	},
	{
		settings: true,
		text: "Invoice date to",
		value: "to",
		valueFilter: 'filter_to',
		func: true,
		model: { value: 'date' },
		sortable: true,
	},
	{
		settings: true,
		text: "Service",
		value: "category",
		valueFilter: 'filter_service_id',
		func: true,
		model: { value: 'list' },
		sortable: true,
	},
	{
		settings: true,
		text: "Amount",
		value: "amount",
		valueFilter: 'filter_amount',
		func: true,
		model: { value: 'number' },
		sortable: true,
		footer: "sum",
		dollar: true,
		toLeft: true,
	},
	{
		settings: true,
		text: "Description",
		value: "description",
		valueFilter: 'filter_description',
		func: true,
		model: { value: 'note' },
		sortable: true,
		toLeft: true,
	},
];
export const safetyStatisticHeaders = [
	{
		settings: true,
		text: "ID",
		value: "customer_id",
		valueFilter: 'filter_customer_id',
		func: false,
		model: { value: 'list' },
		sortable: true,
		footer: "unique"
	},
	{
		settings: true,
		text: "Customer name",
		value: "customer",
		valueFilter: 'filter_customer',
		func: false,
		model: { value: 'list' },
		sortable: true,
		modValue: "isCustomerLink"
	},
	{
		settings: true,
		text: "Balance",
		value: "balance",
		valueFilter: 'filter_balance',
		func: true,
		model: { value: 'number' },
		sortable: true,
		footer: "sum",
		modValue: 'modBalanceTow',
	},
	{
		settings: true,
		text: "Created date",
		value: "create_at",
		valueFilter: 'filter_create_at',
		func: true,
		model: { value: 'date' },
		sortable: true,
	},
	{
		settings: true,
		text: "Q-ty driver",
		value: "drivers",
		valueFilter: 'filter_drivers',
		func: true,
		model: { value: 'number' },
		sortable: true,
		footer: "sum",
		toLeft: true,
	},
];

